import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { cardListStyles } from "@insite/content-library/Components/CardList";
import { wishListCardStyles } from "@insite/content-library/Components/WishListCard";
import { wishListSharingStatusStyles } from "@insite/content-library/Components/WishListSharingStatus";
import { headerStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistoryHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface MyAccountCustomContainerStyles {
    container?: InjectableCss;
}

// headerStyles.toggleFilterGridItem = {
//     width: 1,
//     style: { justifyContent: "flex-end" },
//     css: css`
//         align-items: flex-end;
//     `,
// };

cardListStyles.gridContainer = {
    gap: 0,
};

wishListCardStyles.gridContainer = {
    gap: 5,
    css: css`
        background: #fff;
        padding: 15px;
    `,
};

wishListSharingStatusStyles.statusText = {
    css: css`
        line-height: 24px;
        display: flex;
        align-items: center;
        div[class^="TooltipWrapper"] {
            top: -1px;
            left: 3px;
        }
    `,
};

export const MyAccountContainerStyles: MyAccountCustomContainerStyles = {
    container: {
        css: css`
            border: #e1e1e1 1px solid;
            background: #fafafa;
            padding: 40px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 20px;
                        `,
                        null,
                        css`
                            padding: 30px;
                        `,
                        css`
                            padding: 40px;
                        `,
                        null,
                    ],
                    "min",
                )}
            div[class^="FormFieldStyle"] {
                > label {
                    position: absolute;
                    z-index: 1;
                    left: 20px;
                    background: #fafafa;
                    width: auto;
                    top: 6px;
                    min-height: auto;
                    line-height: 12px;
                }
            }

            [data-test-selector="lineContainer"] {
                div[class^="FormFieldStyle"] {
                    > label {
                        position: static !important;
                    }
                }
            }
            div[class^="PaginationStyle"] {
                label {
                    position: relative;
                    z-index: 0;
                    left: 0;
                    background: #fafafa;
                    width: auto;
                    top: 0px;
                    min-height: auto;
                }
            }
        `,
    },
};

const styles = MyAccountContainerStyles;

const MyAccountCustomContainer: React.FC<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container} data-test-selector="MyAccountWrapper">
            <Zone contentId={id} zoneName="Content1" />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: MyAccountCustomContainer,
    definition: {
        displayName: "My Account Custom Container",
        group: "My Account",
    },
};

export default widgetModule;
